import * as React from 'react';
import {ReactNode, useState} from 'react';
import {faAngleDown} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

interface ToggleSectionProps {
    border?: boolean;
    children: ReactNode;
    title: string;
}

export const ToggleSection = ({border = false, children, title}: ToggleSectionProps) => {
    const [shown, setShown] = useState(true);
    const [smallShown, setSmallShown] = useState(false);
    return (
        <>
            <div
                className={`tw-text-gray-700 tw-font-bold tw-text-[18px] tw-flex tw-justify-between tw-cursor-pointer tw-items-center${
                    border ? ' tw-border-y tw-py-2 tw-px-1 first:tw-mb-[-1px]' : ' tw-m-4'
                }`}
                onClick={() => {
                    setShown(!shown);
                    setSmallShown(!smallShown);
                }}
            >
                {title}{' '}
                <FontAwesomeIcon
                    className="tw-text-gray-700 tw-ml-8"
                    icon={faAngleDown}
                    size="lg"
                    rotation={shown ? 180 : undefined}
                />
            </div>
            <div className={`tw-hidden md:tw-block ${border ? 'tw-m-0' : 'tw-m-4'}`}>{shown && children}</div>
            <div className={`${smallShown ? 'tw-block' : 'tw-hidden'} md:tw-hidden ${border ? 'tw-m-0' : 'tw-m-4'}`}>{children}</div>
        </>
    );
};
